import { DateRange } from '@zapier/design-system';
import { TaskStatus } from '@zapier/design-system-reporting/src/graphql-types';

export type SelectTaskOptions = 'all' | 'shown' | 'none';

export type ActivityFiltersTypes = {
  action: ActionFilterType[];
  date: DateRange;
  page: number | undefined;
  user: string | undefined;
};

export type HistoryFiltersTypes = {
  app: string | undefined;
  dateFilter: DateRange;
  folderId: string | undefined;
  nodeId: string | undefined;
  ownerId: string | undefined;
  page: number;
  search: string;
  status: StatusFilterType[];
};

export type FilterChangeValue =
  | string
  | number
  | DateRange
  | StatusFilterType[]
  | string[]
  | undefined;

export type FilterChangeType = (
  filter: string,
  value: FilterChangeValue
) => void;

export enum MassActionName {
  delete = 'delete',
  replay = 'replay',
}

export type MassActionStatus = {
  [key: string]: TaskStatus;
};

export type MassActionChannel = {
  isDisabled: boolean;
  isRunning: boolean;
  name: MassActionName | null;
  statuses: MassActionStatus;
};

export enum StatusFilterType {
  delayed = 'delayed',
  error = 'error',
  filtered = 'filtered',
  halted = 'halted',
  held = 'held',
  playing = 'playing',
  scheduled = 'scheduled',
  success = 'success',
}

export enum ActionFilterType {
  switched_on = 'switched_on',
  switched_off = 'switched_off',
}
